import { addMonths, format, parseISO } from 'date-fns'

import type { TGrupoMensaisBase } from '@/domain/simulador/gerenciador-mensais.interface'
import type { TGrupoParcelasToUTC } from '@/utils/grupo-parcelas.utils'

export class MensaisMapper {
  static transform(grupo: TGrupoMensaisBase): TGrupoParcelasToUTC[] {
    if (!grupo?.length) return []
    return grupo.flatMap(({ dataInicio, ...mensal }) =>
      dataInicio
        ? [
            {
              parcelas: Array.from({ length: mensal.quantidade }).map((_, i) => ({
                valor: mensal.valor,
                data: format(addMonths(parseISO(dataInicio), i), 'yyyy-MM-dd'),
              })),
            },
          ]
        : [],
    )
  }
}
